/**
 * Clean up the SWR cache.
 */
export function cleanCache(swrConfig) {
    const { cache } = swrConfig || {};

    cache?.clear();
}
